import React from "react";

import RegisterAuditory from "@auditory/component/RegisterAuditory";
import { AUDITORY_MODEL, PAYMENT_MODEL } from "../models/model";
import { SectionPayment } from "../components/SectionPayment";
import { SectionAction } from "../components/SectionAction";

const StepPayment = () => {
  return (
    <>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <SectionPayment {...PAYMENT_MODEL} />
      <SectionAction />
    </>
  );
};

export default StepPayment;
